<template>
  <div class="table-container">
    <v-snackbar v-model="showUpdatePasswordSnackbar" :top="true">
      Password Successfully Updated
      <v-btn dark text v-on:click="navigateRoute('/home')">
        Return to Home Page
      </v-btn>
    </v-snackbar>
    <v-toolbar fill-height row wrap text class="my-2 px-0">
      <v-toolbar-title>
        Update Password
      </v-toolbar-title>
    </v-toolbar>
    <v-form ref="form" v-model="validComputed" class="px-4">
      <v-text-field v-model="oldPassword" :type="showOldPassword ? 'text' : 'password'" :append-icon="showOldPassword ? 'visibility_off' : 'visibility'" v-on:click:append="() => (showOldPassword = !showOldPassword)" v-on:input="resetOldPasswordValidation" :rules="oldPasswordRules" :error="oldPasswordError" :error-messages="oldPasswordErrorMessages" label="Old Password" required></v-text-field>
      <v-text-field v-model="newPassword" :type="showNewPassword ? 'text' : 'password'" :append-icon="showNewPassword ? 'visibility_off' : 'visibility'" v-on:click:append="() => (showNewPassword = !showNewPassword)" v-on:input="resetNewPasswordValidation" :rules="newPasswordRules" :error="newPasswordError" :error-messages="newPasswordErrorMessages" label="New Password" required></v-text-field>
      <v-text-field v-model="confirmNewPassword" :type="showConfirmNewPassword ? 'text' : 'password'" :append-icon="showConfirmNewPassword ? 'visibility_off' : 'visibility'" v-on:click:append="
          () => (showConfirmNewPassword = !showConfirmNewPassword)
        " v-on:input="resetConfirmNewPasswordValidation" :rules="confirmNewPasswordRules" :error="confirmNewPasswordError" :error-messages="confirmNewPasswordErrorMessages" label="Confirm New Password" v-on:keyup.enter="updatePassword" required></v-text-field>

      <span v-if="displayErrorMessageBool" class="red--text">
        {{ errorMessage }}
      </span>

      <v-btn :disabled="!validComputed" color="success" v-on:click="updatePassword">
        Update Password
      </v-btn>
      <v-btn color="error" v-on:click="reset">
        Clear
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    displayErrorMessageBool: false,
    errorMessage: "",
    valid: true,
    showOldPassword: false,
    oldPassword: "",
    oldPasswordError: false,
    oldPasswordErrorMessages: [],
    oldPasswordRules: [v => !!v || "Required"],
    newPassword: "",
    showNewPassword: false,
    newPasswordError: false,
    newPasswordErrorMessages: [],
    newPasswordRules: [
      v => !!v || "Cannot be blank"
      // v => (v && v.length >= 8) || "New Password must be longer than 8 Characters"
    ],
    confirmNewPassword: "",
    showConfirmNewPassword: false,
    confirmNewPasswordError: false,
    confirmNewPasswordErrorMessages: [],
    confirmNewPasswordRules: [
      v => !!v || "Cannot be blank"
      // v => (v && v.length >= 8) || "Confirm New Password must be longer than 8 Characters"
    ],
    showUpdatePasswordSnackbar: false
  }),
  computed: {
    validComputed() {
      if (this.valid) {
        if (
          this.confirmNewPassword.length == 0 ||
          (this.confirmNewPassword.length > 0 &&
            this.confirmNewPassword == this.newPassword)
        ) {
          this.confirmNewPasswordError = false;

          return true;
        } else {
          // update error message
          this.confirmNewPasswordError = true;
          this.confirmNewPasswordErrorMessages.push(
            "New passwords do not match"
          );
        }
      }
      return false;
    }
  },
  methods: {
    navigateRoute: function(newpath) {
      this.$router.push(newpath, () => {});
    },
    validate() {
      if (this.$refs.form.validate()) {
        // this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetOldPasswordValidation() {
      this.oldPasswordError = false;
      this.oldPasswordErrorMessages = [];
      //this.$refs.form.validate();
    },
    resetNewPasswordValidation() {
      this.newPasswordError = false;
      this.newPasswordErrorMessages = [];
      //this.$refs.form.validate();
    },
    resetConfirmNewPasswordValidation() {
      this.confirmNewPasswordError = false;
      this.confirmNewPasswordErrorMessages = [];
      //this.$refs.form.validate();
    },
    updatePassword() {
      if (this.$refs.form.validate()) {
        let userObj = this.$store.getters.getUser;
        let username = "";
        if (userObj != null) {
          username = userObj.username;
        }
        let param = {
          username: username,
          old_password: this.oldPassword,
          new_password: this.newPassword
        };
        axios({
          url: "/api/user/updatepassword",
          data: param,
          method: "PUT"
        })
          .then(response => {
            if (response != null && response.status == 204) {
              this.oldPasswordError = false;
              this.oldPasswordErrorMessages = [];
              this.newPasswordError = false;
              this.newPasswordErrorMessages = [];
              this.confirmNewPasswordError = false;
              this.confirmNewPasswordErrorMessages = [];
              this.showUpdatePasswordSnackbar = true;
            } else {
              this.errorMessage = "Invalid password";
              this.displayErrorMessageBool = true;
            }
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (err.response.data.new_password != null) {
                this.newPasswordErrorMessages = this.newPasswordErrorMessages.concat(
                  err.response.data.new_password
                );
                this.newPasswordError = true;
              }
              if (err.response.data.old_password != null) {
                this.oldPasswordErrorMessages = this.oldPasswordErrorMessages.concat(
                  err.response.data.old_password
                );
                this.oldPasswordError = true;
              }
            }
            this.errorMessage = "Invalid password";
            this.displayErrorMessageBool = true;
          });
      }
    }
  }
};
</script>

<style></style>
